import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`container1break`)
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_chat_message = _resolveComponent("q-chat-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_chat_message, {
      "text-html": "",
      text: [
        _ctx.inputText
      ],
      "text-color": "black",
      "bg-color": "transparent"
    }, null, 8, ["text"])
  ]))
}